import { Clock3, FileCheck2, ListChecks, NotebookText, ShieldCheck, Wrench } from "lucide-react";
import SignalCard from "./SignalCard";
import StatusBadge from "./StatusBadge";
import ClientPortalAccessCard from "./ClientPortalAccessCard";

function OverviewCard({ icon: Icon, title, value, helper }) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="mb-2 flex items-center gap-2 text-slate-700">
        <Icon size={16} />
        <h4 className="text-sm font-semibold">{title}</h4>
      </div>
      <p className="text-2xl font-semibold text-slate-900">{value}</p>
      <p className="mt-1 text-xs text-slate-500">{helper}</p>
    </div>
  );
}

export default function ClientOverviewTab({ data, portalAccess, onOpenPortalAccess, onPortalActivate, onPortalInvite, onPortalOpen }) {
  const actieveWerkbonnen = data.workorders.filter((item) => item.status !== "afgerond").length;
  const openTaken = data.tasks.filter((item) => item.status === "open").length;
  const opnames = Array.isArray(data?.opnames) ? data.opnames : [];

  return (
    <section className="space-y-5">
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        <OverviewCard icon={ListChecks} title="Open opdrachten" value={data.openOpdrachten.length} helper="Actueel klantportfolio" />
        <OverviewCard icon={Wrench} title="Actieve werkbonnen" value={actieveWerkbonnen} helper="Planning en uitvoering" />
        <OverviewCard icon={FileCheck2} title="Recente documenten" value={data.documents.length} helper="Laatste 30 dagen" />
        <OverviewCard icon={Clock3} title="Open taken" value={openTaken} helper="Volgende actie vereist" />
        <OverviewCard icon={NotebookText} title="Opnames" value={opnames.length} helper="In klantdossier" />
        <OverviewCard icon={NotebookText} title="Laatste activiteit" value={data.activityFeed[0]?.datumTijd || "-"} helper={data.activityFeed[0]?.actie || "Geen activiteit"} />
        <OverviewCard icon={ShieldCheck} title="Compliance" value="Concept" helper="Placeholder voor compliance score" />
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
        <h3 className="mb-4 text-sm font-semibold text-slate-900">Opnames / vooronderzoek</h3>
        {opnames.length === 0 ? (
          <p className="text-sm text-slate-500">Nog geen opnames gekoppeld aan deze klant.</p>
        ) : (
          <div className="space-y-3">
            {opnames.slice(0, 6).map((opname) => (
              <div key={opname.id} className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-slate-100 bg-slate-50 p-3 text-sm">
                <div>
                  <p className="font-medium text-slate-800">{opname.titel}</p>
                  <p className="text-slate-500">
                    {opname.type} • {opname.status} • {opname.datum}
                    {opname.projectNummer ? ` • ${opname.projectNummer}` : ""}
                    {opname.workorderNummer ? ` • ${opname.workorderNummer}` : ""}
                  </p>
                </div>
                <a
                  href={`/opname?opnameId=${encodeURIComponent(opname.id)}`}
                  className="rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 hover:bg-slate-100"
                >
                  Open opname
                </a>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
        <h3 className="mb-4 text-sm font-semibold text-slate-900">Signalen en waarschuwingen</h3>
        <div className="grid gap-3 lg:grid-cols-3">
          {data.signals.map((signal) => (
            <SignalCard key={signal.id} signal={signal} />
          ))}
        </div>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
        <h3 className="mb-4 text-sm font-semibold text-slate-900">Laatste activiteit</h3>
        <ul className="space-y-3">
          {data.activityFeed.map((item) => (
            <li key={item.id} className="flex flex-wrap items-center gap-2 border-b border-slate-100 pb-3 text-sm last:border-b-0 last:pb-0">
              <span className="font-medium text-slate-800">{item.datumTijd}</span>
              <span className="text-slate-500">{item.actor}</span>
              <span className="text-slate-600">{item.actie}</span>
              <StatusBadge value={item.actor === "Systeem" ? "compliance" : "normaal"} />
            </li>
          ))}
        </ul>
      </div>

      <ClientPortalAccessCard
        portalAccess={portalAccess}
        onManage={onOpenPortalAccess}
        onActivate={onPortalActivate}
        onInvite={onPortalInvite}
        onOpenPortal={onPortalOpen}
      />
    </section>
  );
}
